import React from "react";
import Slider from "./Slider";

function App() {
  return <Slider />;
}

export default App;
